import I18n from 'I18n';
import { SkeletonDiv } from '../../common/SkeletonDiv';
import PropertyInformationPopoverValueRow from './PropertyInformationPopoverValueRow';
import { Text } from 'foundations-components/components/Text';
import { getIconComponentForPropertyType, hasPropertyTypeIcon } from 'customer-data-filters-ui/utils/getIconComponent';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import PropertyInformationPopoverIcon from './PropertyInformationPopoverIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propertyTypeMessages = {
  bool: 'customerDataFiltersUI.propertyInformationPopover.details.propertyType.values.bool',
  date: 'customerDataFiltersUI.propertyInformationPopover.details.propertyType.values.date',
  datetime: 'customerDataFiltersUI.propertyInformationPopover.details.propertyType.values.datetime',
  enumeration: 'customerDataFiltersUI.propertyInformationPopover.details.propertyType.values.enumeration',
  number: 'customerDataFiltersUI.propertyInformationPopover.details.propertyType.values.number',
  string: 'customerDataFiltersUI.propertyInformationPopover.details.propertyType.values.string',
  object_coordinates: 'customerDataFiltersUI.propertyInformationPopover.details.propertyType.values.objectCoordinates',
  phone_number: 'customerDataFiltersUI.propertyInformationPopover.details.propertyType.values.phoneNumber'
};
const hasPropertyTypeMessage = s => {
  return s in propertyTypeMessages;
};
export default function PropertyInformationPopoverPropertyType({
  propertyType,
  loading
}) {
  if (loading && typeof propertyType === 'undefined') {
    return /*#__PURE__*/_jsxs(PropertyInformationPopoverValueRow, {
      children: [/*#__PURE__*/_jsx(SkeletonDiv, {
        blockSize: "18px",
        inlineSize: "16px"
      }), /*#__PURE__*/_jsx(SkeletonDiv, {
        blockSize: "18px",
        inlineSize: "100px",
        "aria-label": I18n.text('customerDataFiltersUI.propertyInformationPopover.details.propertyType.loading')
      })]
    });
  }
  const IconComponent = typeof propertyType !== 'undefined' && hasPropertyTypeIcon(propertyType) ? getIconComponentForPropertyType(propertyType) : null;
  if (propertyType && hasPropertyTypeMessage(propertyType)) {
    return /*#__PURE__*/_jsxs(PropertyInformationPopoverValueRow, {
      children: [IconComponent && /*#__PURE__*/_jsx(PropertyInformationPopoverIcon, {
        IconComponent: IconComponent
      }), /*#__PURE__*/_jsx(Text, {
        truncate: true,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: propertyTypeMessages[propertyType]
        })
      })]
    });
  } else {
    // missing or unknown property type
    Raven.capturePageEvent('prop-info-pop-missing-property-type', {
      extra: {
        propertyType
      }
    });
    return /*#__PURE__*/_jsx(PropertyInformationPopoverValueRow, {
      children: /*#__PURE__*/_jsx(Text, {
        truncate: true,
        use: "disabled",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.propertyInformationPopover.details.propertyType.unknown"
        })
      })
    });
  }
}